module.exports = __webpack_public_path__ + "media/images/pokerroom/fulltilt/step4-pict02-full-b43ee5956dc791b25c169a29ff14303b.jpg";